import { c as _c } from "react/compiler-runtime";
import { type FC, type ReactNode } from "react";
import { Icons } from "./icons";
interface FunFactProps {
  children: ReactNode;
}
export const FunFact: FC<FunFactProps> = t0 => {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-gold-500 dark:text-gold-500 shrink-0 mt-1"><Icons.Lightbulb className="w-6 h-6" /></div>;
    t2 = <h4 className="font-bold text-gold-600 dark:text-gold-500 text-sm uppercase mb-1">Ciekawostka</h4>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <div className="mt-8 bg-slate-100 dark:bg-slate-800/50 border-l-4 border-gold-400 dark:border-gold-500 p-4 rounded-r-lg animate-fade-in flex gap-4 items-start">{t1}<div>{t2}<p className="text-sm text-slate-600 dark:text-slate-300 italic leading-relaxed">"{children}"</p></div></div>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};